import { render, staticRenderFns } from "./userViewRatingPublished.vue?vue&type=template&id=5a5a1dd2&"
import script from "./userViewRatingPublished.vue?vue&type=script&lang=js&"
export * from "./userViewRatingPublished.vue?vue&type=script&lang=js&"
import style0 from "./userViewRatingPublished.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports